import { AccessPointsUtil } from '@/util/access_points'
import { toolkitUrls } from '@/util/links'
import type { GoalHit } from '@/goals/goal_types'
import type { LibraryGoal } from '@/library/library_types'

export type RecentlyViewedContentType = 'goals' | 'strategies' | 'resources'

export type RecentlyViewedTab = {
  contentType: RecentlyViewedContentType
  label: string
  apiContentType: 'goal' | 'strategy' | 'resource'
  limit: number
  browseUrl: string
  browseLabel: string
}

export const RECENTLY_VIEWED_TABS: RecentlyViewedTab[] = [
  {
    contentType: 'goals',
    label: 'Goals',
    apiContentType: 'goal',
    limit: 4,
    browseUrl: toolkitUrls.browse,
    browseLabel: 'goals'
  },
  {
    contentType: 'strategies',
    label: 'Strategies',
    apiContentType: 'strategy',
    limit: 3,
    browseUrl: toolkitUrls.browseStrategies,
    browseLabel: 'strategies'
  },
  {
    contentType: 'resources',
    label: 'Resources',
    apiContentType: 'resource',
    limit: 3,
    browseUrl: toolkitUrls.browseAssessments,
    browseLabel: 'assessments'
  }
]

export function recentlyViewedPageUrl(contentType: RecentlyViewedContentType): string {
  return `${toolkitUrls.home}/v/library/recently_viewed/${contentType}`
}

// A viewed goal comes back as its goal document, so it is reshaped into the Algolia record the browse goal card draws.
export function goalHitFromViewedGoal(goal: LibraryGoal): GoalHit {
  const subject = goal.subject ?? ''
  const hasProgressMonitoring = (goal.goal_resources?.length ?? 0) > 0
  const levels = goal.access_point_level ? AccessPointsUtil.orderedValues : []
  return {
    objectID: goal.uuid,
    uuid: goal.uuid,
    title: goal.title,
    goal_text: goal.plain_goal_text,
    subject,
    primary_subject: subject,
    domains: goal.subject_domains,
    grades: goal.grades,
    level: goal.access_point_level ?? '',
    levels,
    access_point_level: goal.access_point_level,
    super_page: goal.super_page,
    score: 0,
    standard_set_refs: goal.standard_set_refs,
    has_progress_monitoring: hasProgressMonitoring,
    resource_languages: goal.resource_languages
  }
}
